var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GeoprocessingChart',{attrs:{"chart-data":_vm.fakeResponse,"title":"Total Buffer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }